import { BuildingMenuType } from '@/enums';
import type { KioskSelectedCategory } from '@/services/dto';
import { useConfigStore } from '@/stores';
import { getMergedCategoryCodes, sortCategories } from '@/utils/floor-guide';
import { useMemo, useState } from 'react';

export const useBuildingCategory = () => {
    const language = useConfigStore((state) => state.config?.ui?.language);
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string | undefined>(undefined);

    const selectedCategories = useConfigStore(
        (state) =>
            state.config.server?.buildingMenus?.[language]?.find((menu) => menu.menuType === BuildingMenuType.FLOOR)?.selectedCategories
    );

    const sortedBuildingCategories = useMemo(() => {
        return sortCategories(selectedCategories);
    }, [selectedCategories]);

    const selectedCategory = useMemo(() => {
        if (!selectedCategoryCode) {
            return null;
        }

        return (
            sortedBuildingCategories.find(
                (category) =>
                    category.categoryCode === selectedCategoryCode ||
                    category.mergeCategoryCode?.includes(selectedCategoryCode)
            ) || null
        );
    }, [selectedCategoryCode, sortedBuildingCategories]);

    const groupedCategoryByClientCode = useMemo(() => {
        const categoryMap: { [clientCode: string]: string[] } = {};

        sortedBuildingCategories?.forEach((category: KioskSelectedCategory) => {
            if (category.clientCode) {
                categoryMap[category.clientCode] = getMergedCategoryCodes(category);
            }
        });

        return categoryMap;
    }, [sortedBuildingCategories]);

    return {
        selectedCategoryCode,
        selectedCategory,
        setSelectedCategoryCode,
        sortedBuildingCategories,
        groupedCategoryByClientCode,
        selectedCategories: sortedBuildingCategories,
    };
};
